import React from 'react';
import { useCouponIssueHistoryList } from '../../../hooks/coupon/useCouponIssueHistoryList';
import CouponIssueHistoryListSearchBox from '../../coupon/issueHistory/CouponIssueHistoryListSearchBox';
import CouponIssueHistoryList from '../../coupon/issueHistory/CouponIssueHistoryList';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { CouponIssueHistoryListWrapStyle } from './style';

export const CouponIssueHistoryListWrap = () => {
  const {
    list,
    totalCount,
    adminSelectList,
    pagination,
    searchData,
    onSearch,
    onClear,
    onSearchDataChange,
    onPageChange,
  } = useCouponIssueHistoryList();

  const getList = (data: Record<string, unknown>) => {
    if (data.pagination) {
      const pag = data.pagination as { pageNum: number; pageSize: number };
      onPageChange(pag.pageNum, pag.pageSize);
    }
  };

  return (
    <CouponIssueHistoryListWrapStyle className="coupon-issue-history-wrap">
      <CouponIssueHistoryListSearchBox
        setData={(data: { path: string[]; value: unknown }) => {
          if (data.path.length > 0) {
            onSearchDataChange(data.path[0], data.value);
          }
        }}
        adminSelectList={adminSelectList}
        searchData={searchData}
        getList={(data: Record<string, unknown>) => {
          if (data.searchOption) {
            onSearch();
          } else {
            onClear();
          }
        }}
      />

      <CouponIssueHistoryList
        couponIssueHistoryList={list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={pagination}
        getList={getList}
      />
    </CouponIssueHistoryListWrapStyle>
  );
};
